export { default } from './listOfDoctors';
